<template>
    <div id="page-wrapper">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            {{$t('withdrawal.title')}}
            <a class="btn-settings" href=""><i class="fa fa-cog"></i></a>
          </h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="col-lg-4 col-xl-4 col-xxl-3">
          <div class="panel panel-default">
            <div class="panel-footer border-none">
              <total-balance @balanceChanged="balanceChanged"></total-balance>
              <div class="alert alert-danger" role="alert" v-show="!isAllowed">
                {{$t('withdrawal.warnings.not_available_for_demo_accounts')}}
              </div>
              <div class="alert alert-danger" role="alert" v-show="noEnoughFunds && isAllowed">
                {{$t('withdrawal.warnings.no_enough_funds')}}
              </div>
            </div>
          </div>
          <div class="align-justify" style="color: white;" v-html="$t('withdrawal.explanation')">
          </div>
        </div>
        <div class="col-lg-8 col-xl-8 col-xxl-9">
          <div class="panel panel-default">
            <div class="panel-heading clearfix">
              <ul class="nav nav-tabs pull-left">
                <li class="active">
                  <a href="#bank-transfer" v-on:click="setWithdrawalType('1', $t('withdrawal.bank_transfer'))" data-toggle="tab">{{$t('withdrawal.bank_transfer')}}</a>
                </li>
                <li>
                  <a href="#credit-debit-card" v-on:click="setWithdrawalType('2', $t('withdrawal.credit_debit'))" data-toggle="tab">{{$t('withdrawal.credit_debit')}}</a>
                </li>
              </ul>

            </div>
            <div class="panel-body">
              <div class="alert alert-danger" role="alert" v-show="!isAllowed">
                {{$t('withdrawal.warnings.not_available_for_demo_accounts')}}
              </div>
               <div class="alert alert-danger" role="alert" v-show="noEnoughFunds && isAllowed">
                {{$t('withdrawal.warnings.no_enough_funds')}}
              </div>
              <div class="tab-content">
                <div class="tab-pane fade in active" id="bank-transfer">

                  <form>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9 col-md-9">
                        <h3>1. {{$t('withdrawal.personal_details')}}</h3>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="fullName" class="label-horizontal">{{$t('withdrawal.first_name')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input readonly type="text" class="form-control" id="fullName" v-model="user.firstName" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="fullName" class="label-horizontal">{{$t('withdrawal.last_name')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input readonly type="text" class="form-control" id="fullName" v-model="user.lastName" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="address" class="label-horizontal">{{$t('withdrawal.address')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input readonly type="text" class="form-control" id="address" v-model="user.fullAddress" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="phone" class="label-horizontal">{{$t('withdrawal.phone')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input readonly type="text" class="form-control" id="phone" v-model="user.phone" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="email" class="label-horizontal">{{$t('withdrawal.email')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input readonly type="email" class="form-control" id="email" v-model="user.email" />
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9">
                        <h3>2. {{$t('withdrawal.bank_details')}}</h3>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="bank_account_number" class="label-horizontal">{{$t('withdrawal.bank_account_number')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text"  id="bank_account_number" v-model="bankTransfer.bankAccountNumber" :class="!$v.bankTransfer.bankAccountNumber.$invalid ? 'form-control' : 'form-control is-invalid'"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="bank_name" class="label-horizontal">{{$t('withdrawal.bank_name')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" id="bank_name" v-model="bankTransfer.bankName" :class="!$v.bankTransfer.bankName.$invalid ? 'form-control' : 'form-control is-invalid'"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="bank_address" class="label-horizontal">{{$t('withdrawal.bank_address')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" id="bank_address" v-model="bankTransfer.bankAddress" :class="!$v.bankTransfer.bankAddress.$invalid ? 'form-control' : 'form-control is-invalid'"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="swift_code" class="label-horizontal">{{$t('withdrawal.swift_code')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" id="swift_code" v-model="bankTransfer.swiftCodeBic" :class="!$v.bankTransfer.swiftCodeBic.$invalid ? 'form-control' : 'form-control is-invalid'"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="iban" class="label-horizontal">{{$t('withdrawal.iban')}}</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" id="iban" v-model="bankTransfer.iban" :class="!$v.bankTransfer.iban.$invalid ? 'form-control' : 'form-control is-invalid'"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9">
                        <h3>3. {{$t('withdrawal.amount')}}</h3>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">
                        <label for="amount" class="label-horizontal">$</label>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <input type="text" id="amount" v-model="bankTransfer.amount" :class="!$v.bankTransfer.amount.$invalid ? 'form-control number' : 'form-control is-invalid number'"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 col-md-3">&nbsp;</div>
                      <div class="col-sm-8 col-md-9">
                        <spin-button v-bind:disabled="!isAllowed || noEnoughFunds || $v.bankTransfer.$invalid" id="btnSave" :button-text="$t('shared.buttons.confirm')" :loading="isLoading" :loading-text="$t('shared.buttons.processing')" :onClick="save"></spin-button>
                        <button type="button" class="btn btn-default mrg-b-25" v-on:click="doCancel">{{$t('shared.buttons.cancel')}}</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="tab-pane fade" id="credit-debit-card">
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">&nbsp;</div>
                    <div class="col-sm-8 col-md-9 col-md-9">
                      <h3>1. {{$t('withdrawal.personal_details')}}</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="fullName" class="label-horizontal">{{$t('withdrawal.first_name')}}</label>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <input readonly type="text" class="form-control" id="fullName" v-model="user.firstName" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="fullName" class="label-horizontal">{{$t('withdrawal.last_name')}}</label>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <input readonly type="text" class="form-control" id="fullName" v-model="user.lastName" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="address" class="label-horizontal">{{$t('withdrawal.address')}}</label>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <input readonly type="text" class="form-control" id="address" v-model="user.fullAddress" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="phone" class="label-horizontal">{{$t('withdrawal.phone')}}</label>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <input readonly type="text" class="form-control" id="phone" v-model="user.phone" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="email" class="label-horizontal">{{$t('withdrawal.email')}}</label>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <input readonly type="email" class="form-control" id="email" v-model="user.email" />
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">&nbsp;</div>
                    <div class="col-sm-8 col-md-9">
                      <h3>2. {{$t('withdrawal.credit_card_details')}}</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="last_four_digits" class="label-horizontal">{{$t('withdrawal.last_four_digits')}}</label>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <input type="text" :class="!$v.creditCard.lastFourDigits.$invalid ? 'form-control number' : 'form-control is-invalid number'" id="last_four_digits" v-model="creditCard.lastFourDigits" :state="!$v.creditCard.lastFourDigits.$invalid" maxlength="4" />
                      <!--<span class="text-danger field-validation-error" data-valmsg-for="last_four_digits" v-show="$v.model.lastFourDigits.$invalid"
                            data-valmsg-replace="true">{{$t('withdrawal.warnings.four_digits_wrong_format')}}</span>-->
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="amount_credit" class="label-horizontal">{{$t('withdrawal.amount')}}</label>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <input type="text" id="amount_credit" v-model="creditCard.amount" :class="!$v.creditCard.amount.$invalid ? 'form-control number' : 'form-control is-invalid number'" :state="!$v.creditCard.amount.$invalid"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">&nbsp;</div>
                    <div class="col-sm-8 col-md-9">
                      <spin-button v-bind:disabled="!isAllowed || noEnoughFunds || $v.creditCard.$invalid" id="btnSave" :button-text="$t('shared.buttons.confirm')" :loading="isLoading" :loading-text="$t('shared.buttons.processing')" :onClick="save"></spin-button>
                      <button type="button" class="btn btn-default mrg-b-25" v-on:click="doCancel">{{$t('shared.buttons.cancel')}}</button>
                    </div>
                  </div>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
 
</template>

<script>

  import ProfileService from '@/services/ProfileService';
  import WithdrawalService from '@/services/WithdrawalService';
  import AuthService from '@/services/AuthService';
  import EventBus from '@/event-bus';
  import swal from 'sweetalert2';
  import { validationMixin } from "vuelidate";
  import { required, minLength } from "vuelidate/lib/validators";
  import siteConfiguration from '@/config';
  import AccountService from '@/services/AccountService';


  let srv = new ProfileService();
  let withdrawalSrv = new WithdrawalService();

  let accountService = new AccountService();

  const isInt = (value) => /^[0-9]*$/.test(value);
  const isDecimal = (value) => /^\d+(\.\d{1,2})?$/.test(value);
  const isValidAmount = (value) => value > 0 && isDecimal;

  export default {

    data() {
      return {
        isLoading : false,
        withdrawalType: {
            text: this.$t('withdrawal.bank_transfer'),
            value : '1'
        },
        bankTransfer:{ amount : '0.00', currency : siteConfiguration.DEFAULT_CURRENCY },
        creditCard:{ amount : '0.00', currency : siteConfiguration.DEFAULT_CURRENCY },
        user: {},
        isAllowed: true,
        noEnoughFunds : false,
        defaultMT4Account : {}
      };
    },
    created() {

      accountService.getDefaultMt4Account().then(r =>{
        this.defaultMT4Account = r.data.accountType.mT4Server;
      });
      
      this.isAllowed = !this.defaultMT4Account.isDemo;
      srv.get().then((u) => {
        this.user = u.data;
      });
      EventBus.$on('onSetDefaultMt4Account', (mt4) => {
        this.isAllowed = !mt4.accountType.mT4Server.isDemo;
      });
    },
    methods: {
      balanceChanged(profit) {
        this.noEnoughFunds = profit <= 0;
      },
      setWithdrawalType(value, text){
          this.withdrawalType.value = value;
          this.withdrawalType.text = text;
      },
      save() {

        let model = this.withdrawalType.value == '1' ? this.bankTransfer : this.creditCard;
        model.Mt4Account = this.defaultMT4Account;
        model.withdrawalType = this.withdrawalType;

        this.isLoading = true;
        withdrawalSrv.save(model).then((r) => {
          swal({
            type: 'success',
            title: 'OK',
            text: 'Your withdrawal request has been sent',
            showConfirmButton: true,
          }).then((r) => {
              this.$router.push('/client/dashboard');
          });
        }).catch((error) => {
          swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: true,
          });
        }).finally(()=>{
          this.isLoading = false;
        });
      },
      doCancel() {
        this.$router.push('/client');
      }
    },
   validations : {
      creditCard: {
          lastFourDigits: {
            required,
            minLength: minLength(4),
            numberValid: isInt
          },
          amount:{
            required,
            numberValid: isDecimal,
            isValidAmount
          }
      },
      bankTransfer : {
          bankAccountNumber: {
            required
          },
          bankName: {
            required
          },
          bankAddress: {
            required
          },
          swiftCodeBic: {
            required
          },
          iban: {
            required
          },
          amount:{
            required,
            numberValid: isDecimal,
            isValidAmount
          }
      }
    },

  };
</script>




// WEBPACK FOOTER //
// src/components/views/Withdrawal.vue